import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EdgePatientEnrollmentApi } from '@trialcard/apigateway.client/edgePatientEnrollmentApi';

import { AxiosInstance, AxiosRequestConfig , AxiosResponse } from 'axios';
import {
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    EnterpriseCoordinatorSharedAddressUpsearchModel,
    EnterpriseCoordinatorSharedEmailAddressUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactUpsearchModel,
    EnterpriseCoordinatorSharedPhoneUpsearchModel,
    UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel,
    EnterpriseCoordinatorAccountServiceModelsAccountContactPreferenceModel,
    UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel,
    UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    EnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel,
    PayorCoverageEligibilityRequestModel,
    EnterpriseCoordinatorSiteServiceModelsSitePointOfContactUpsearchModel
} from '@trialcard/apigateway.models';
import * as enums from '@trialcard/enums';

import moment, { Moment } from 'moment';
import { EdgeEnrollmentApi } from '@trialcard/apigateway.client';
import { Settings } from '~/services/settings';
import EligibilityModule from '~/store/eligibility';
import SurveyModule from '~/store/survey';

@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    @Resolve
    public patientEnrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    public enrollmentApi!: EdgeEnrollmentApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public survey!: SurveyModule;

    @Resolve
    public eligibility!: EligibilityModule;

    alternativeEnrollment: boolean | null = null;

    medicalMemberNumber: string | null = '';
    memberNumber: string | null = '';
    patientId = '';
    defaultPrescriberData = [
        {
            model: {
                firstName: '',
                lastName: '',
                npi: '',
                accountRelationshipIsPrimary: true,
                prescriberLicenses: [],
                externalIds: [],
                addresses: [],
                phoneNumbers: [],
                emailAddresses: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[];

    defaultSiteData = [
        {
            model: {
                accountRelationshipIsPrimary: true,
                siteRoleType: enums.RoleType.PrescriberSite,
                pointOfContacts: [],
                description: '',
                addresses: [
                    {
                        addressOne: '',
                        addressTwo: '',
                        zip: '',
                        city: '',
                        state: '',
                    },
                ],
                contacts: [],
                emailAddresses: [],
                externalIds: [],
                phoneNumbers: [{
                    phoneType: 1,
                    phoneNumber: '',
                    phonePurpose: 1,
                },
                {
                    phoneType: 3,
                    phoneNumber: '',
                    phonePurpose: 8,
                },],
                globalIds: [],
            },
        },
    ] as UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[];

    defaultPayorObject =  {
        model: {
            payorId: (null as unknown) as number,
            payorType: (null as unknown) as number,
            accountRelationshipIsPrimary: true,
            payorGroup: '',
            payorName: '',
            webAddresses: [],
            addresses: [],
            phoneNumbers: [
                {
                    phoneType: 1,
                    phoneNumber: '',
                    phonePurpose: 1,
                },
                {
                    phoneType: 3,
                    phoneNumber: '',
                    phonePurpose: 8,
                },
            ],
            emailAddresses: [],
            contacts: [],
            payorBenefit: {
                dateOfBirth: null as Moment | null,
                policyHolderFirstName: '',
                policyHolderLastName: '',
                relationshipToPatient: undefined,
                policyNumber: '',
                planType: undefined,
            },
        },
    }
    defaultPayorData = [
    ] as UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[];
    defaultPatientInformationData = {
        firstName: '' as string,
        lastName: '' as string,
        dateOfBirth: null as Moment | null,
        addresses: [] as EnterpriseCoordinatorSharedAddressUpsearchModel[],
        emailAddresses: [] as EnterpriseCoordinatorSharedEmailAddressUpsearchModel[],
        phoneNumbers: [] as EnterpriseCoordinatorSharedPhoneUpsearchModel[],
        gender: null as enums.Gender | null,
    };
    expirationDate: moment.Moment | null = moment();
    alreadyEnrolled = false as boolean;
    patientInformationData = { ...this.defaultPatientInformationData };
    prescriberData = [ ...this.defaultPrescriberData ];
    siteData = [ ...this.defaultSiteData ];
    payorData = [ ...this.defaultPayorData ];

    @Mutation
    public setMedicalMemberNumber(medical: string | null) {
        this.medicalMemberNumber = medical;
    }
    @Mutation
    public updatePatientId(patientId:string){
        this.patientId = patientId;
    }
    @Mutation
    public setMemberNumber(mn: string | null) {
        this.memberNumber = mn;
    }

    @Mutation
    public setAlreadyEnrolled(newEnrollmentStatus: boolean) {
        this.alreadyEnrolled = newEnrollmentStatus;
    }

    // @Mutation
    // setCurrentPhoneType(value: string){
    //     this.currentPhoneTypeOption = value;
    // }

    @Mutation
    public setExpirationDate(expirationDate: Moment | null) {
        this.expirationDate = expirationDate;
    }

    @Action
    public updateAlreadyEnrolled(newEnrollmentStatus: boolean) {
        this.setAlreadyEnrolled(newEnrollmentStatus);
    }

    @Action({ rawError: true })
    public clearEnrollment() {
        this.updatePatientInformation({ ...this.defaultPatientInformationData });

        this.setMedicalMemberNumber(null);
        this.setMemberNumber(null);
    }
    @Mutation
    public async updatePatientInformation(newPatientInformation: typeof EnrollmentModule.prototype.patientInformationData) {
        this.patientInformationData = { ...this.patientInformationData, ...newPatientInformation };
    }
     @Mutation
    public async updatePrescribers(newPrescriberData: UpsearchModelEnterpriseCoordinatorPrescriberServiceModelsPrescriberUpsearchModel[]) {
        this.prescriberData = [...newPrescriberData];
    }

    @Mutation
    public async updateSites(newSites: UpsearchModelEnterpriseCoordinatorSiteServiceModelsSiteUpsearchModel[]) {
        this.siteData = [...newSites];
    }

    @Mutation
    public async updatePayors(newPayorData: UpsearchModelEnterpriseCoordinatorPayorServiceModelsPayorUpsearchModel[]) {
        this.payorData = [...newPayorData];
    }
    @Action({ rawError: true })
    public async submitToAPI() {
        let response = null;
        try {
            const patient = {
                account: {
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            ...this.patientInformationData,
                            middleName: '',
                            suffix: '',
                            nickname: '',
                            contacts: '',
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                            accountStatus: 1,
                            contactPreferences: [],
                            contacts: [],
                            externalIds: this.patientId ? [{
                                        externalIdType: enums.AccountExternalIdType.THIRDPARTYID,
                                        externalId: this.patientId,
                            }] : []
                        },
                    } as unknown as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    prescriberData: this.prescriberData,
                    siteData: this.siteData,
                    payorData:this.payorData,
                    surveySessionData: [this.survey.sessionId] as number[],
                    sourceId: +this.settings.sourceId,
                },
                accountAttestations: [{ code: 'eServiceAttestion', startDate: moment() }],
                caseInitiator: enums.EnrollPatientCaseInitiator.patient,
            } as unknown ;
            const axios: AxiosInstance = (this.enrollmentApi as any).axios;
            const axiosRequest: AxiosRequestConfig = {
                url: 'edge/patientEnrollment/enrollPatient',
                method: 'POST',
                data: patient,
                headers: {
                    'x-program-id': this.settings.programId!,
                },
            };
            await Promise.all([
                (this.enrollmentApi as any).authentications.ApiKey.applyToRequest(axiosRequest),
                (this.enrollmentApi as any).authentications.Bearer.applyToRequest(axiosRequest),
                (this.enrollmentApi as any).authentications.Token.applyToRequest(axiosRequest),
            ]);
            const data = await axios.request(axiosRequest);
            // console.log(data)
            response =  data
            // response = await this.patientEnrollmentApi.patientEnrollmentEnrollPatient(patient, this.settings.programId);
        } catch(error){
            console.log(error)
            response = { status: 400 } as AxiosResponse;
        }
        return response;
    }


}
